/* Waxit nozzle orifice calculator. LPM = K * (size/10) * sqrt(PSI), fitted to the Waxit flow chart. */
(function () {
  var K = 0.05979, SIZES = [20, 25, 30, 35, 40, 45, 50], PSIS = [];
  for (var i = 0; i < 19; i++) PSIS.push(1015 + i * 145);
  function lpm(size, psi) { return K * (size / 10) * Math.sqrt(psi); }
  function pad(n) { return ('000' + n).slice(-3); }
  function parseSize(s) { var d = String(s || '').replace(/[^0-9]/g, ''); if (!d) return null; var n = parseInt(d.slice(-2), 10); return SIZES.indexOf(n) > -1 ? n : null; }

  function init(root) {
    if (root.dataset.wxNozInit) return;
    root.dataset.wxNozInit = '1';
    var unit = 'psi';
    var pressure = parseFloat(root.dataset.pressure) || 2175, flow = parseFloat(root.dataset.flow) || 9;
    var own = parseSize(root.dataset.size), optIndex = parseInt(root.dataset.optionIndex, 10);
    var pIn = root.querySelector('[data-wx-noz-pressure]'), fIn = root.querySelector('[data-wx-noz-flow]');
    var sizeOut = root.querySelector('[data-wx-noz-size]'), noteOut = root.querySelector('[data-wx-noz-note]');
    var table = root.querySelector('[data-wx-noz-table]'), headRow = table.tHead.rows[1], body = table.tBodies[0];

    PSIS.forEach(function (p) { var th = document.createElement('th'); th.className = 'wx-noz__psi'; th.dataset.psi = p; th.textContent = p; headRow.appendChild(th); });
    SIZES.forEach(function (s, ri) {
      var tr = document.createElement('tr');
      var th = document.createElement('th'); th.className = 'wx-noz__size'; th.dataset.size = s; th.textContent = pad(s); tr.appendChild(th);
      if (ri === 0) { var l = document.createElement('th'); l.className = 'wx-noz__lpm'; l.rowSpan = SIZES.length; l.textContent = 'Litres per minute'; tr.appendChild(l); }
      PSIS.forEach(function (p) {
        var td = document.createElement('td'); td.dataset.size = s; td.dataset.psi = p; td.textContent = lpm(s, p).toFixed(2); td.title = 'Set calculator to this cell';
        td.addEventListener('click', function () { pressure = p; flow = +lpm(s, p).toFixed(1); unit === 'bar' ? (pIn.value = Math.round(pressure / 14.504)) : (pIn.value = Math.round(pressure)); fIn.value = flow; render(); });
        tr.appendChild(td);
      });
      body.appendChild(tr);
    });

    function render() {
      var psi = Math.max(1, pressure);
      var ideal = flow / (K * Math.sqrt(psi)) * 10;
      var size = SIZES[0];
      SIZES.forEach(function (s) { if (s <= ideal + 1.5) size = s; });
      var idx = SIZES.indexOf(size);
      if (ideal - size > 2.5 && idx < SIZES.length - 1) size = SIZES[idx + 1];
      var col = PSIS.reduce(function (a, b) { return Math.abs(b - psi) < Math.abs(a - psi) ? b : a; });
      var low = ideal < SIZES[0] - 2.5, high = ideal > SIZES[SIZES.length - 1] + 2.5;
      sizeOut.textContent = pad(size);
      noteOut.textContent = low ? 'Below our smallest size. Check your figures or ask us.' : high ? 'Above our largest size. Ask us about larger orifices.' : 'Recommended for ' + flow + ' L/min at ' + Math.round(psi) + ' PSI';
      Array.prototype.forEach.call(headRow.querySelectorAll('.wx-noz__psi'), function (th) { th.classList.toggle('is-col', +th.dataset.psi === col); });
      Array.prototype.forEach.call(body.querySelectorAll('.wx-noz__size'), function (th) { th.classList.toggle('is-row', +th.dataset.size === size); th.classList.toggle('is-own', +th.dataset.size === own); });
      Array.prototype.forEach.call(body.querySelectorAll('td'), function (td) {
        var s = +td.dataset.size, p = +td.dataset.psi, hit = s === size && p === col;
        td.classList.toggle('is-hit', hit);
        td.classList.toggle('is-near', !hit && (s === size || p === col));
        td.classList.toggle('is-own', !hit && s === own);
      });
    }
    function readPressure() { var v = parseFloat(pIn.value) || 0; pressure = unit === 'bar' ? v * 14.504 : v; render(); }
    pIn.addEventListener('input', readPressure);
    fIn.addEventListener('input', function () { flow = parseFloat(fIn.value) || 0; render(); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-wx-noz-unit]'), function (b) {
      b.addEventListener('click', function () {
        if (unit === b.dataset.wxNozUnit) return;
        unit = b.dataset.wxNozUnit;
        Array.prototype.forEach.call(root.querySelectorAll('[data-wx-noz-unit]'), function (x) { x.classList.toggle('is-on', x === b); });
        pIn.value = unit === 'bar' ? Math.round(pressure / 14.504) : Math.round(pressure);
      });
    });
    // Follow the selected variant. wx-product.js publishes wx:variant; Dawn's own selector publishes variant:change.
    function onVariant(v) { if (!v || !(optIndex >= 0) || !v.options) return; var s = parseSize(v.options[optIndex]); if (s) { own = s; render(); } }
    document.addEventListener('wx:variant', function (e) { onVariant(e.detail); });
    document.addEventListener('variant:change', function (e) { onVariant(e.detail && e.detail.variant); });
    render();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-wx-noz]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
